import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Country } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";

const countryController = new Country();

export function CountryForm({ country, close, onReload }) {
  const { accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: {
      code: country?.code || "",
      name: country?.name || "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required(t("code_required")),
      name: Yup.string().required(t("name_required")),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (country) {
          await countryController.updateCountry(accessToken, country._id, values);
          toast.success(t("country_updated"));
        } else {
          await countryController.createCountry(accessToken, values);
          toast.success(t("country_created"));
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || t("error_saving"));
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<><span style={{ fontWeight: "bold" }}>{t("code")}</span> <span style={{ color: "red" }}>*</span></>}
        name="code"
        value={formik.values.code}
        onChange={(e) => formik.setFieldValue("code", e.target.value.toUpperCase())}
        error={formik.errors.code}
        placeholder="Ej: AR"
      />
      <Form.Input
        label={<><span style={{ fontWeight: "bold" }}>{t("name")}</span> <span style={{ color: "red" }}>*</span></>}
        name="name"
        value={formik.values.name}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("name", v.charAt(0).toUpperCase() + v.slice(1));
        }}
        error={formik.errors.name}
        placeholder="Ej: Argentina"
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        {/* Piloto: paleta verde del cambio "colores gestión" (misma que las
            tablas de Usuarios/Sitios/etc.), probando acá antes de extenderla
            a otros formularios de carga. */}
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#95A472", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (country ? t("update") : t("save"))}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>
          {t("cancel")}
        </button>
      </div>
    </Form>
  );
}
